import React from 'react';

import ProPerk from './ProPerk';
import { ProPerks } from './constants';
import { ProSubscriberNotBotProps } from './interfaces';

const NON_PRO_HEADLINE = 'Exclusive and Rare Access';
const PRO_HEADLINE = 'Explore Your Pro Benefits';

const ProSubscription = ({ isProSubscriberNotBot }: ProSubscriberNotBotProps) => {
  return (
    <div className="border-0 border-b border-solid border-grayscale-beige py-32 lg:px-40 lg:pt-64">
      <div className="flex flex-col text-center">
        <h2 className="m-0 p-0 text-center font-suisse-works text-headline-xs text-primary-black sm:text-headline-md">
          {isProSubscriberNotBot ? PRO_HEADLINE : NON_PRO_HEADLINE}
        </h2>
        <p className="m-0 justify-self-start p-0 text-subheadline-md text-grayscale-charcoal">
          Your Pro subscription includes:
        </p>
      </div>
      <div className="mt-32 sm:mt-16">
        <ProPerk isProSubscriberNotBot={isProSubscriberNotBot} {...ProPerks.data} />
      </div>
    </div>
  );
};

export default ProSubscription;
